// import React, { useState, useEffect } from 'react';
// import '../../Dashboard Style/GenealogyTree.css';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// // Import your local icons from the Dashboard folder
// import adminIcon from './admin-icon.png'; 
// import userIcon from './user-icon.png';
// import { getPlacementByUsercodeApi } from '../../Services/Operations/ProductAPI';

// const GenealogyTree = () => {
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   // Initialize tree with local admin icon for the Root
//   const [treeData, setTreeData] = useState({
//     id: userData?.user_code || '',
//     name: userData?.name || 'Loading...',
//     image: adminIcon, // Use admin icon for the top-level user
//     children: [],
//     isLoaded: false
//   });

//   useEffect(() => {
//     if (userData?.user_code && authToken) {
//       handleNodeClick(treeData.id);
//     }
//   }, [userData, authToken]);

// const fetchChildrenData = async (userCode) => {
//   try {
//     console.log("Fetching children for user code:", userCode);
    
//     const response = await getPlacementByUsercodeApi(authToken, userCode);
    
//     console.log("API Response:", response);
    
//     if (response.status && response.data) {
//       // Transform the API response to match your tree structure
//       const childrenData = response.data.map(item => ({
//         id: item.id || item.user_code || '', // Use item.id from your response
//         name: item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || item.accountName || 'Unknown',
//         image: item.image || userIcon, 
//         children: item.children || [],
//         isLoaded: item.isLoaded || false,
//         position: item.position || 'Left', // Default to Left
//         isEmpty: !item.id || item.id === '', // Check if id is empty
//         // Include additional data if available
//         email: item.email,
//         leftCount: item.leftCount || 0,
//         rightCount: item.rightCount || 0,
//         status: item.status,
//         level: item.level || 0
//       }));
      
//       console.log("Transformed children data:", childrenData);
//       return childrenData;
//     } else {
//       console.warn("API returned false status:", response.message);
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching placement data:", error);
//     toast.error('Failed to load placement data');
//     return [];
//   }
// };

//   const handleNodeClick = async (targetId) => {
//     // Prevent clicking if there is no user code
//     if (!targetId) return;

//     const newChildren = await fetchChildrenData(targetId);
//     const updateNodes = (node) => {
//       if (node.id === targetId) {
//         if (node.children.length === 0) {
//           return { ...node, children: newChildren, isLoaded: true };
//         }
//         return node;
//       }
//       return {
//         ...node,
//         children: node.children ? node.children.map(updateNodes) : []
//       };
//     };
//     setTreeData(prevTree => updateNodes(prevTree));
//   };

//   const renderNode = (node, isRoot = false) => {
//     const hasChildren = node.children && node.children.length > 0;
//     // Check if node is disabled
//     const isDisabled = !node.id || node.isEmpty;

//     return (
//       <li key={node.id || Math.random()}>
//         <div 
//           className={`member-view-box ${isDisabled ? 'node-disabled' : ''}`} 
//           onClick={() => !isDisabled && handleNodeClick(node.id)}
//         >
//           {!isRoot && (
//             <div className="member-header">
//               <span>{node.name}</span>
//             </div>
//           )}
//           <div className="member-image">
//             <img src={node.image} alt="Member" />
//           </div>
        
//         </div>
        
//         {hasChildren && (
//           <ul className="active">
//             {node.children.map(child => renderNode(child, false))}
//           </ul>
//         )}
//       </li>
//     );
//   };
//   return (
//     <div className="genealogy-body genealogy-scroll">
//       <div className="genealogy-tree">
//         {treeData.id ? (
//           <ul>{renderNode(treeData, true)}</ul>
//         ) : (
//           <p className="loading-text">Loading Tree...</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GenealogyTree;

// import React, { useState, useEffect } from 'react';
// import '../../Dashboard Style/GenealogyTree.css';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// // Import your local icons from the Dashboard folder
// import adminIcon from './admin-icon.png'; 
// import userIcon from './user-icon.png';
// import { getPlacementByUsercodeApi } from '../../Services/Operations/ProductAPI';

// const GenealogyTree = () => {
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   // Track which nodes are expanded and which have been clicked once
//   const [expandedNodes, setExpandedNodes] = useState(new Set());
//   const [firstClickNodes, setFirstClickNodes] = useState(new Set());
//   const [hoveredNode, setHoveredNode] = useState(null);

//   // Initialize tree with local admin icon for the Root
//   const [treeData, setTreeData] = useState({
//     id: userData?.user_code || '',
//     name: userData?.name || 'Loading...',
//     image: adminIcon,
//     children: [],
//     isLoaded: false
//   });

//   useEffect(() => {
//     if (userData?.user_code && authToken) {
//       // Initially expand the root node
//       setExpandedNodes(new Set([treeData.id]));
//       handleNodeClick(treeData.id, true); // Force load root children
//     }
//   }, [userData, authToken]);
// const fetchChildrenData = async (userCode) => {
//   try {
//     const response = await getPlacementByUsercodeApi(authToken, userCode);
    
//     if (response.status && response.data) {
//       return response.data.map(item => ({
 
//   ...item,
//   // Ensure every node has an ID, even if it's just a temporary one
//   id: item.id || item.user_code || `temp-id-${Math.random()}`, 
//   name: item.name || item.accountName || 'Empty Slot',
//   // ... rest of code
//         image: item.image || userIcon, 
//         children: [],
//         isLoaded: false,
//         isEmpty: !item.id && !item.user_code
//       }));
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching placement data:", error);
//     toast.error('Failed to load placement data');
//     return [];
//   }
// };

//   const handleNodeClick = async (targetId, forceExpand = false) => {
//     // Prevent clicking if there is no user code
//     if (!targetId) return;

//     // If it's the first click (not expanded yet and not already first-clicked)
//     if (!expandedNodes.has(targetId) && !firstClickNodes.has(targetId) && !forceExpand) {
//       // Mark as first click and show hover/tooltip
//       setFirstClickNodes(prev => new Set([...prev, targetId]));
//       setHoveredNode(targetId);
//       return;
//     }

//     // Second click or force expand - actually load children
//     if (!expandedNodes.has(targetId) || forceExpand) {
//       const newChildren = await fetchChildrenData(targetId);
//       const updateNodes = (node) => {
//         if (node.id === targetId) {
//           if (node.children.length === 0 || forceExpand) {
//             return { ...node, children: newChildren, isLoaded: true };
//           }
//           return node;
//         }
//         return {
//           ...node,
//           children: node.children ? node.children.map(updateNodes) : []
//         };
//       };
//       setTreeData(prevTree => updateNodes(prevTree));
//       setExpandedNodes(prev => new Set([...prev, targetId]));
//     } else {
//       // If already expanded, collapse it
//       setExpandedNodes(prev => {
//         const newSet = new Set([...prev]);
//         newSet.delete(targetId);
//         return newSet;
//       });
//     }
    
//     // Remove from first click set and close hover
//     setFirstClickNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(targetId);
//       return newSet;
//     });
//     setHoveredNode(null);
//   };

//   const handleCloseHover = () => {
//     setHoveredNode(null);
//     setFirstClickNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(hoveredNode);
//       return newSet;
//     });
//   };

//   // Render hover tooltip for first click
// const renderHoverTooltip = (node) => {
//   if (hoveredNode !== node.id) return null;

//   return (
//     <div className="node-hover-tooltip">
//       <div className="tooltip-content" style={{ padding: '8px', minWidth: '160px' }}>
//         <button 
//           className="close-tooltip-btn" 
//           onClick={(e) => {
//             e.stopPropagation();
//             handleCloseHover();
//           }}
//           style={{ fontSize: '14px', top: '2px', right: '5px' }}
//         >
//           ×
//         </button>
        
//         {/* Main Node Info */}
//          <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
//   <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
//   <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position}</p>

//   {/* Sponsor Section */}
//   {node.sponsor && (
//     <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
//       <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
//         Sponsor
//       </p>
//       <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
//       <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
//       <p style={{ margin: '0' }}><span>Email:</span> {node.sponsor.email}</p>
//     </div>
//   )}

//   {/* Placement Section */}
//   {node.placement && (
//     <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
//       <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
//         Placement
//       </p>
//       <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
//       <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
//       <p style={{ margin: '0' }}><span>Email:</span> {node.placement.email}</p>
//     </div>
//   )}
//         </div>
//       </div>
//     </div>
//   );
// };

//   const renderNode = (node, isRoot = false) => {
//     console.log("node: ",node)
//     const hasChildren = node.children && node.children.length > 0;
//     const isDisabled = !node.id || node.isEmpty;
//     const isExpanded = expandedNodes.has(node.id);
//     const isFirstClick = firstClickNodes.has(node.id);

//     return (
//       <li key={node.id || Math.random()}>
//         <div className="node-container">
//           <div 
//             className={`member-view-box ${isDisabled ? 'node-disabled' : ''} ${isFirstClick ? 'first-click' : ''} ${isExpanded ? 'expanded' : ''}`} 
//             onClick={(e) => {
//   e.stopPropagation();
//   // Call the handler regardless so it can show the tooltip
//   handleNodeClick(node.id, false, node); 
// }}
//             onMouseLeave={() => {
//               // Auto-close hover after delay
//               if (isFirstClick && hoveredNode === node.id) {
//                 setTimeout(() => {
//                   handleCloseHover();
//                 }, 3000);
//               }
//             }}
//           >
//             {!isRoot && (
//               <div className="member-header">
//                 <span>{node.name}</span>
//               </div>
//             )}
//             <div className="member-image">
//               <img src={node.image} alt="Member" />
//               {isFirstClick && !isExpanded && (
//                 <div className="first-click-indicator">👆</div>
//               )}
//               {isExpanded && (
//                 <div className="expanded-indicator">▼</div>
//               )}
//             </div>
           
//           </div>
          
//           {isFirstClick && renderHoverTooltip(node)}
//         </div>
        
       
//           <ul className="active">
//             {node.children.map(child => renderNode(child, false))}
//           </ul>
        
//       </li>
//     );
//   };

//   return (
//     <div className="genealogy-body genealogy-scroll">
//       <div className="genealogy-tree">
       
//           <ul>{renderNode(treeData, true)}</ul>
       
//       </div>
//     </div>
//   );
// };

// export default GenealogyTree;


// import React, { useState, useEffect, useCallback } from 'react';
// import '../../Dashboard Style/GenealogyTree.css';
// import { useSelector } from 'react-redux';
// import adminIcon from './admin-icon.png'; 
// import userIcon from './user-icon.png';
// import { getPlacementByUsercodeApi } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify'; // Make sure to install react-toastify

// // Search Section Component
// const SearchSection = ({ onSearch, onMyView, searchLoading, searchValue, setSearchValue }) => {
//   const handleSearch = () => {
//     if (searchValue.trim()) {
//       onSearch(searchValue.trim());
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   return (
//     <div className="search-section">
//       <div className="search-container">
//         <div className="search-input-wrapper">
//           <input
//             type="text"
//             value={searchValue}
//             onChange={(e) => setSearchValue(e.target.value)}
//             onKeyPress={handleKeyPress}
//             placeholder="Search By User-Code..."
//             className="search-input"
//             maxLength={20}
//           />
//         </div>
        
//         <button 
//           onClick={handleSearch}
//           disabled={!searchValue.trim() || searchLoading}
//           className="search-button"
//         >
//           {searchLoading ? 'Searching...' : 'Search Now'}
//         </button>
        
//         <button className="my-view-button" onClick={onMyView}>
//           Go to My view
//         </button>
//       </div>
//     </div>
//   );
// };

// const GenealogyTree = () => {
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   const [expandedNodes, setExpandedNodes] = useState(new Set());
//   const [firstClickNodes, setFirstClickNodes] = useState(new Set());
//   const [hoveredNode, setHoveredNode] = useState(null);
  
//   // Search state
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [searchValue, setSearchValue] = useState('');
//   const [error, setError] = useState(null);

//   // Active volumes globally
//   const [activeVolumes, setActiveVolumes] = useState({ left: 0, right: 0 });

//   const [treeData, setTreeData] = useState({
//     id: userData?.user_code || '',
//     user_code: userData?.user_code || '', 
//     package_id: userData?.package_id || 0,
//     name: userData?.name || 'Loading...',
//     account_name: userData?.account_name || '', 
//     image: adminIcon,
//     children: [],
//     isLoaded: false,
//     leftVolume: 0,
//     rightVolume: 0
//   });

//   // Store original tree data for reset
//   const [originalTreeData, setOriginalTreeData] = useState(null);

//   useEffect(() => {
//     if (userData?.user_code && authToken) {
//       setExpandedNodes(new Set([treeData.id]));
//       handleNodeClick(treeData.id, true);
//     }
//   }, [userData, authToken]);

//   // Store original tree data when it's loaded
//   useEffect(() => {
//     if (treeData && !originalTreeData) {
//       setOriginalTreeData(treeData);
//     }
//   }, [treeData]);

//   const handleCloseHover = () => {
//     setHoveredNode(null);
//     setFirstClickNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(hoveredNode);
//       return newSet;
//     });
//   };

//   const fetchChildrenData = async (userCode) => {
//     try {
//       const response = await getPlacementByUsercodeApi(authToken, userCode);
//       console.log("API Response for volumes:", response);
//       const apiChildren = response.data || [];
//       const leftVolume = response.leftVolume || 0;
//       const rightVolume = response.rightVolume || 0;
      
//       if (response && response.status === true) {
//         return {
//           children: apiChildren.map(item => ({
//             ...item,
//             id: item.user_code || item.id || `temp-${Math.random()}`,
//             user_code: item.user_code || item.id,
//             name: item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Unnamed',
//             image: item.image || userIcon,
//             children: [],
//             isLoaded: false,
//             leftVolume: item.leftVolume || item.left_volume || 0,
//             rightVolume: item.rightVolume || item.right_volume || 0,
//             position: item.position || 'N/A',
//             account_name: item.account_name || item.accountName || 'N/A',
//             sponsor_code: item.sponsor_code || 'N/A'
//           })),
//           leftVolume: leftVolume,
//           rightVolume: rightVolume
//         };
//       }
//       return { children: [], leftVolume: 0, rightVolume: 0 };
//     } catch (error) {
//       console.error("Error fetching placement data:", error);
//       return { children: [], leftVolume: 0, rightVolume: 0 };
//     }
//   };

//   // Validate user code format (10 digits)
//   const isValidUserCode = (code) => {
//     // Check if it's a valid WQ code format (WQ followed by digits)
//     const wqCodePattern = /^WQ\d{8}$/; // WQ + 8 digits = 10 characters
//     return wqCodePattern.test(code);
//   };

//   // Handle search
// const handleSearch = async (userCode) => {
//   if (!treeData) return;

//   if (!isValidUserCode(userCode)) {
//     toast.error('Invalid user code format (WQ + 8 digits)');
//     return;
//   }

//   setSearchLoading(true);

//   try {
//     const response = await getPlacementByUsercodeApi(authToken, userCode);
    
//      if (response && response.status === true) {
//         const newRootData = {
//           id: response.user_code,
//           user_code: response.user_code,
//           package_id: response.package_id || 0,
//           name: response.name || `${response.firstName || ''} ${response.lastName || ''}`.trim() || 'User',
//           account_name: response.account_name || response.accountName || '',
//           image: adminIcon,
//           children: response.data || [],
//           isLoaded: true,
//           leftVolume: response.leftVolume || 0,
//           rightVolume: response.rightVolume || 0
//         };

//         setTreeData(newRootData);
       
//         setActiveVolumes({
//           left: response.leftVolume || 0,
//           right: response.rightVolume || 0
//         });
       
//       } else {
//       toast.error(`User code ${userCode} not found`);
//     }
//   } catch (err) {
//     console.error("Search Error:", err);
//     toast.error('An error occurred while searching');
//   } finally {
//     setSearchLoading(false);
//   }
// };

//   // Handle "Go to My view" button - Refresh to original user
//   const handleGoToMyView = () => {
//     if (userData?.user_code) {
//       // Reset to original user
//       setTreeData({
//         id: userData.user_code,
//         user_code: userData.user_code,
//         package_id: userData.package_id || 0,
//         name: userData.name || 'Loading...',
//         account_name: userData.account_name || '',
//         image: adminIcon,
//         children: [],
//         isLoaded: false,
//         leftVolume: 0,
//         rightVolume: 0
//       });
      
//       setExpandedNodes(new Set([userData.user_code]));
//       setActiveVolumes({ left: 0, right: 0 });
//       setHoveredNode(null);
//       setSearchValue('');
      
//       // Trigger a fresh load of the original user's tree
//       setTimeout(() => {
//         handleNodeClick(userData.user_code, true);
//       }, 100);
      
//       toast.info('Returned to your view', {
//         position: "top-right",
//         autoClose: 3000,
//       });
//     }
//   };

//   // Handle double click on node to make it root
//   const handleNodeDoubleClick = async (nodeId) => {
//     if (!nodeId) return;
    
//     try {
//       const response = await getPlacementByUsercodeApi(authToken, nodeId);
      
//       if (response && response.status === true) {
//         const newRootData = {
//           id: nodeId,
//           user_code: nodeId,
//           package_id: response.package_id || 0,
//           name: response.name || `${response.firstName || ''} ${response.lastName || ''}`.trim() || 'User',
//           account_name: response.account_name || response.accountName || '',
//           image: adminIcon,
//           children: response.data || [],
//           isLoaded: true,
//           leftVolume: response.leftVolume || 0,
//           rightVolume: response.rightVolume || 0
//         };

//         setTreeData(newRootData);
//         setExpandedNodes(new Set([nodeId]));
//         setActiveVolumes({
//           left: response.leftVolume || 0,
//           right: response.rightVolume || 0
//         });
        
//         toast.success(`Now viewing ${nodeId}`, {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       }
//     } catch (error) {
//       toast.error('Failed to load user data', {
//         position: "top-right",
//         autoClose: 5000,
//       });
//     }
//   };

//   const handleNodeClick = async (targetId, forceExpand = false) => {
//     if (!targetId) return;
//     const isNodeExpanded = expandedNodes.has(targetId);
//     const isFirstClick = firstClickNodes.has(targetId);

//     if (!isNodeExpanded && !isFirstClick && !forceExpand) {
//       setFirstClickNodes(prev => new Set([...prev, targetId]));
//       setHoveredNode(targetId);
//       return;
//     }

//     if (!isNodeExpanded || forceExpand) {
//       const response = await fetchChildrenData(targetId);
      
//       // UPDATE GLOBAL VOLUMES
//       setActiveVolumes({
//         left: response.leftVolume,
//         right: response.rightVolume
//       });

//       setTreeData(prevTree => {
//         if (prevTree.id === targetId) {
//           return {
//             ...prevTree,
//             children: response.children,
//             isLoaded: true,
//             leftVolume: response.leftVolume,
//             rightVolume: response.rightVolume
//           };
//         }

//         const updateRecursive = (node) => {
//           if (node.id === targetId) {
//             return { 
//               ...node, 
//               children: response.children, 
//               isLoaded: true,
//               leftVolume: response.leftVolume,  
//               rightVolume: response.rightVolume 
//             };
//           }
//           return {
//             ...node,
//             children: node.children ? node.children.map(updateRecursive) : []
//           };
//         };
//         return updateRecursive(prevTree);
//       });

//       setExpandedNodes(prev => new Set([...prev, targetId]));
//     } else {
//       setExpandedNodes(prev => {
//         const newSet = new Set([...prev]);
//         newSet.delete(targetId);
//         return newSet;
//       });
//     }
//     setFirstClickNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(targetId);
//       return newSet;
//     });
//     setHoveredNode(null);
//   };

//   const renderHoverTooltip = (node) => {
//     if (hoveredNode !== node.id) return null;

//     return (
//       <div className="node-hover-tooltip">
//         <div className="tooltip-content">
//           <button 
//             className="close-tooltip-btn" 
//             onClick={(e) => {
//               e.stopPropagation();
//               handleCloseHover();
//             }}
//           >
//             ×
//           </button>
          
//           <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
//             <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
//             <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position || 'N/A'}</p>
//             <p style={{ margin: '0 0 2px 0' }}><span>Code:</span> {node.user_code}</p>
//             <p style={{ margin: '0 0 2px 0' }}><span>Acc:</span> {node.account_name}</p>

//             {/* Volume Section */}
//             <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
//               <div>
//                 <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>LEFT VOL</p>
//                 <p style={{ margin: '0', color: '#27ae60' }}>${node.leftVolume !== undefined ? node.leftVolume : 0}</p>
//               </div>
//               <div style={{ textAlign: 'right' }}>
//                 <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>RIGHT VOL</p>
//                 <p style={{ margin: '0', color: '#27ae60' }}>${node.rightVolume !== undefined ? node.rightVolume : 0}</p>
//               </div>
//             </div>

//             {/* Sponsor Section */}
//             {node.sponsor && (
//               <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
//                 <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
//                   Sponsor
//                 </p>
//                 <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
//                 <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderNode = (node, isRoot = false) => {
//     const hasChildren = node.children && node.children.length > 0;
//     const isExpanded = expandedNodes.has(node.id);
//     const isFirstClick = firstClickNodes.has(node.id);
//     const isEmptyNode = !node.user_code || node.user_code === 'null' || node.user_code === null;

//     const pkgId = Number(node.package_id) || 0;
//     let statusClass = 'node-inactive';
//     if (!isEmptyNode) {
//       statusClass = pkgId > 1 ? 'node-premium' : 'node-active';
//     }
    
//     return (
//       <li key={node.id || Math.random()}>
//         <div className={`node-container ${isRoot ? 'root-node-wrapper' : ''}`}>
          
//           <div 
//             className={`member-view-box ${isEmptyNode ? 'empty-node' : ''} ${statusClass} ${isFirstClick ? 'first-click' : ''} ${isExpanded ? 'expanded' : ''}`} 
//             onClick={(e) => {
//               e.stopPropagation();
//               handleNodeClick(node.id);
//             }}
//             onDoubleClick={() => handleNodeDoubleClick(node.id)}
//           >
//             <div className="member-header">
//               <span>{isEmptyNode ? 'Empty Position' : (node.name || 'Unnamed')}</span>
//             </div>
//             <div className="member-image">
//               <img 
//                 src={isEmptyNode ? userIcon : (node.image || userIcon)} 
//                 alt="Member" 
//                 className={isEmptyNode ? 'empty-image' : ''}
//               />
//               {!isEmptyNode && statusClass === 'node-premium' && <div className="package-badge">★</div>}
//               {isEmptyNode && <div className="empty-indicator">⛔</div>}
//               {isExpanded && <div className="expanded-indicator">▼</div>}
//             </div>
//           </div>
          
//           {isFirstClick && renderHoverTooltip(node)}
//         </div>
        
//         {hasChildren && isExpanded && (
//           <ul className="active">
//             {node.children.map(child => renderNode(child, false))}
//           </ul>
//         )}
//       </li>
//     );
//   };

//   const handleRetry = () => {
//     setError(null);
//     if (userData?.user_code) {
//       handleNodeClick(userData.user_code, true);
//     }
//   };

//   return (
//     <div className="genealogy-container">
//       {/* Search Section */}
//       <SearchSection 
//         onSearch={handleSearch}
//         onMyView={handleGoToMyView}
//         searchLoading={searchLoading}
//         searchValue={searchValue}
//         setSearchValue={setSearchValue}
//       />
      
//       {/* Error Message */}
//       {error && (
//         <div className="error-message">
//           <p>Error: {error}</p>
//           <button onClick={handleRetry} className="retry-btn">
//             Retry
//           </button>
//         </div>
//       )}

//       <div className="genealogy-body genealogy-scroll">
//         <div className="tree-legend">
//           <div className="legend-item"><span className="dot premium"></span> Plan Purchase</div>
//           <div className="legend-item"><span className="dot active"></span> Id Active</div>
//           <div className="legend-item"><span className="dot inactive"></span> Inactive User</div>
//           <div className="legend-item"><span className="dot empty"></span> Empty Position</div>
//         </div>

//         <div className="genealogy-tree">
//           {/* Fixed position volumes */}
//           <div className="fixed-volume-container">
//             <div className="side-volume-box left-side">
//               <div className="vol-label">LEFT VOLUME</div>
//               <div className="vol-value">${activeVolumes.left}</div>
//             </div>

//             <ul>{renderNode(treeData, true)}</ul>

//             <div className="side-volume-box right-side">
//               <div className="vol-label">RIGHT VOLUME</div>
//               <div className="vol-value">${activeVolumes.right}</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GenealogyTree;



import React, { useState, useEffect, useCallback } from 'react';
import '../../Dashboard Style/GenealogyTree.css';
import { useSelector } from 'react-redux';
import adminIcon from './admin-icon.png'; 
import userIcon from './user-icon.png';
import { getPlacementByUsercodeApi } from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify'; // Make sure to install react-toastify

// Search Section Component
const SearchSection = ({ onSearch, onMyView, searchLoading, searchValue, setSearchValue }) => {
  const handleSearch = () => {
    if (searchValue.trim()) {
      onSearch(searchValue.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="search-section">
      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Search By User-Code..."
            className="search-input"
            maxLength={20}
          />
        </div>
        
        <button 
          onClick={handleSearch}
          disabled={!searchValue.trim() || searchLoading}
          className="search-button"
        >
          {searchLoading ? 'Searching...' : 'Search Now'}
        </button>
        
        <button className="my-view-button" onClick={onMyView}>
          Go to My view
        </button>
      </div>
    </div>
  );
};

const GenealogyTree = () => {
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);

  const [expandedNodes, setExpandedNodes] = useState(new Set());
  const [firstClickNodes, setFirstClickNodes] = useState(new Set());
  const [hoveredNode, setHoveredNode] = useState(null);
  
  // Search state
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [error, setError] = useState(null);

  // Active volumes globally
  const [activeVolumes, setActiveVolumes] = useState({ left: 0, right: 0 });

  const [treeData, setTreeData] = useState({
    id: userData?.user_code || '',
    user_code: userData?.user_code || '', 
    package_id: userData?.package_id || 0,
    name: userData?.name || 'Loading...',
    account_name: userData?.account_name || '', 
    image: adminIcon,
    children: [],
    isLoaded: false,
    leftVolume: 0,
    rightVolume: 0
  });

  // Store original tree data for reset
  const [originalTreeData, setOriginalTreeData] = useState(null);

  useEffect(() => {
    if (userData?.user_code && authToken) {
      setExpandedNodes(new Set([treeData.id]));
      handleNodeClick(treeData.id, true);
    }
  }, [userData, authToken]);

  // Store original tree data when it's loaded
  useEffect(() => {
    if (treeData && !originalTreeData) {
      setOriginalTreeData(treeData);
    }
  }, [treeData]);

  const handleCloseHover = () => {
    setHoveredNode(null);
    setFirstClickNodes(prev => {
      const newSet = new Set([...prev]);
      newSet.delete(hoveredNode);
      return newSet;
    });
  };

  const fetchChildrenData = async (userCode) => {
    try {
      const response = await getPlacementByUsercodeApi(authToken, userCode);
      console.log("API Response for volumes:", response);
      const apiChildren = response.data || [];
      const leftVolume = response.leftVolume || 0;
      const rightVolume = response.rightVolume || 0;
      
      if (response && response.status === true) {
        return {
          children: apiChildren.map(item => ({
            ...item,
            id: item.user_code || item.id || `temp-${Math.random()}`,
            user_code: item.user_code || item.id,
            name: item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Unnamed',
            image: item.image || userIcon,
            children: [],
            isLoaded: false,
            leftVolume: item.leftVolume || item.left_volume || 0,
            rightVolume: item.rightVolume || item.right_volume || 0,
            position: item.position || 'N/A',
            account_name: item.account_name || item.accountName || 'N/A',
            sponsor_code: item.sponsor_code || 'N/A'
          })),
          leftVolume: leftVolume,
          rightVolume: rightVolume
        };
      }
      return { children: [], leftVolume: 0, rightVolume: 0 };
    } catch (error) {
      console.error("Error fetching placement data:", error);
      return { children: [], leftVolume: 0, rightVolume: 0 };
    }
  };

  // Validate user code format (10 digits)
  const isValidUserCode = (code) => {
    // Check if it's a valid WQ code format (WQ followed by digits)
    const wqCodePattern = /^WQ\d{8}$/; // WQ + 8 digits = 10 characters
    return wqCodePattern.test(code);
  };

// Handle search
// Handle search
const handleSearch = async (userCode) => {
  if (!treeData) return;

  if (!isValidUserCode(userCode)) {
    toast.error('Invalid user code format (WQ + 8 digits)');
    return;
  }

  setSearchLoading(true);

  try {
    const response = await getPlacementByUsercodeApi(authToken, userCode);
    console.log("response search : ", response);
    
    if (response && response.status === true) {
      // The response contains data array which are the children of the searched user
      // We need to create a root node for the searched user
      const searchedUserCode = userCode;
      
      // Create a root node for the searched user
      const newRootData = {
        id: searchedUserCode,
        user_code: searchedUserCode,
        package_id: response.package_id || 0,
        // FIX: Use the name field directly from the response
        name: response.name || `${response.firstName || ''} ${response.lastName || ''}`.trim() || 'User',
        account_name: response.account_name || response.accountName || '',
        image: adminIcon,
        // Map the response.data array to children
        children: (response.data || []).map(item => ({
          id: item.user_code || item.id,
          user_code: item.user_code || item.id,
          package_id: item.package_id || 0,
          // FIX: Use the name field for children as well
          name: item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Unnamed',
          account_name: item.account_name || item.accountName || '',
          image: item.image || userIcon,
          position: item.position || 'N/A',
          sponsor: item.sponsor || null,
          placement: item.placement || null,
          leftVolume: item.leftVolume || item.left_volume || 0,
          rightVolume: item.rightVolume || item.right_volume || 0,
          children: [],
          isLoaded: false
        })),
        isLoaded: true,
        leftVolume: response.leftVolume || response.left_volume || 0,
        rightVolume: response.rightVolume || response.right_volume || 0
      };

      setTreeData(newRootData);
      setExpandedNodes(new Set([searchedUserCode]));
      setActiveVolumes({
        left: response.leftVolume || response.left_volume || 0,
        right: response.rightVolume || response.right_volume || 0
      });
      
      toast.success(`User ${userCode} found and loaded`, {
        position: "top-right",
        autoClose: 3000,
      });
      
      setSearchValue('');
    } else {
      toast.error(`User code ${userCode} not found`);
    }
  } catch (err) {
    console.error("Search Error:", err);
    toast.error('An error occurred while searching');
  } finally {
    setSearchLoading(false);
  }
};

  // Handle "Go to My view" button - Refresh to original user
  const handleGoToMyView = () => {
    if (userData?.user_code) {
      // Reset to original user
      setTreeData({
        id: userData.user_code,
        user_code: userData.user_code,
        package_id: userData.package_id || 0,
        name: userData.name || 'Loading...',
        account_name: userData.account_name || '',
        image: adminIcon,
        children: [],
        isLoaded: false,
        leftVolume: 0,
        rightVolume: 0
      });
      
      setExpandedNodes(new Set([userData.user_code]));
      setActiveVolumes({ left: 0, right: 0 });
      setHoveredNode(null);
      setSearchValue('');
      
      // Trigger a fresh load of the original user's tree
      setTimeout(() => {
        handleNodeClick(userData.user_code, true);
      }, 100);
      
      toast.info('Returned to your view', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  // Handle double click on node to make it root
  const handleNodeDoubleClick = async (nodeId) => {
    if (!nodeId) return;
    
    try {
      const response = await getPlacementByUsercodeApi(authToken, nodeId);
      
      if (response && response.status === true) {
        const newRootData = {
          id: nodeId,
          user_code: nodeId,
          package_id: response.package_id || 0,
          name: response.name || `${response.firstName || ''} ${response.lastName || ''}`.trim() || 'User',
          account_name: response.account_name || response.accountName || '',
          image: adminIcon,
          children: response.data || [],
          isLoaded: true,
          leftVolume: response.leftVolume || 0,
          rightVolume: response.rightVolume || 0
        };

        setTreeData(newRootData);
        setExpandedNodes(new Set([nodeId]));
        setActiveVolumes({
          left: response.leftVolume || 0,
          right: response.rightVolume || 0
        });
        
        toast.success(`Now viewing ${nodeId}`, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Failed to load user data', {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  const handleNodeClick = async (targetId, forceExpand = false) => {
    if (!targetId) return;
    const isNodeExpanded = expandedNodes.has(targetId);
    const isFirstClick = firstClickNodes.has(targetId);

    if (!isNodeExpanded && !isFirstClick && !forceExpand) {
      setFirstClickNodes(prev => new Set([...prev, targetId]));
      setHoveredNode(targetId);
      return;
    }

    if (!isNodeExpanded || forceExpand) {
      const response = await fetchChildrenData(targetId);
      
      // UPDATE GLOBAL VOLUMES
      setActiveVolumes({
        left: response.leftVolume,
        right: response.rightVolume
      });

      setTreeData(prevTree => {
        if (prevTree.id === targetId) {
          return {
            ...prevTree,
            children: response.children,
            isLoaded: true,
            leftVolume: response.leftVolume,
            rightVolume: response.rightVolume
          };
        }

        const updateRecursive = (node) => {
          if (node.id === targetId) {
            return { 
              ...node, 
              children: response.children, 
              isLoaded: true,
              leftVolume: response.leftVolume,  
              rightVolume: response.rightVolume 
            };
          }
          return {
            ...node,
            children: node.children ? node.children.map(updateRecursive) : []
          };
        };
        return updateRecursive(prevTree);
      });

      setExpandedNodes(prev => new Set([...prev, targetId]));
    } else {
      setExpandedNodes(prev => {
        const newSet = new Set([...prev]);
        newSet.delete(targetId);
        return newSet;
      });
    }
    setFirstClickNodes(prev => {
      const newSet = new Set([...prev]);
      newSet.delete(targetId);
      return newSet;
    });
    setHoveredNode(null);
  };

  const renderHoverTooltip = (node) => {
    if (hoveredNode !== node.id) return null;

    return (
      <div className="node-hover-tooltip">
        <div className="tooltip-content">
          <button 
            className="close-tooltip-btn" 
            onClick={(e) => {
              e.stopPropagation();
              handleCloseHover();
            }}
          >
            ×
          </button>
          
          <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
            <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
            <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position || 'N/A'}</p>
            <p style={{ margin: '0 0 2px 0' }}><span>Code:</span> {node.user_code}</p>
            <p style={{ margin: '0 0 2px 0' }}><span>Acc:</span> {node.account_name}</p>

            {/* Volume Section */}
            <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>LEFT VOL</p>
                <p style={{ margin: '0', color: '#27ae60' }}>${node.leftVolume !== undefined ? node.leftVolume : 0}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>RIGHT VOL</p>
                <p style={{ margin: '0', color: '#27ae60' }}>${node.rightVolume !== undefined ? node.rightVolume : 0}</p>
              </div>
            </div>

            {/* Sponsor Section */}
            {node.sponsor && (
              <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
                <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
                  Sponsor
                </p>
                <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
                <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
              </div>
            )}
             {node.placement && (
    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
        Placement
      </p>
      <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
      <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
      {/* <p style={{ margin: '0' }}><span>Email:</span> {node.placement.email}</p> */}
    </div>
  )}
          </div>
        </div>
      </div>
    );
  };

const renderNode = (node, isRoot = false) => {
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedNodes.has(node.id);
  const isFirstClick = firstClickNodes.has(node.id);
  const isEmptyNode = !node.user_code || node.user_code === 'null' || node.user_code === null;

  const pkgId = Number(node.package_id) || 0;
  let statusClass = 'node-inactive';
  if (!isEmptyNode) {
    statusClass = pkgId > 1 ? 'node-premium' : 'node-active';
  }
  
  return (
    <li key={node.id || Math.random()}>
      <div className={`node-container ${isRoot ? 'root-node-wrapper' : ''}`}>
        
        <div 
          className={`member-view-box ${isEmptyNode ? 'empty-node' : ''} ${statusClass} ${isFirstClick ? 'first-click' : ''} ${isExpanded ? 'expanded' : ''}`} 
          onClick={(e) => {
            e.stopPropagation();
            handleNodeClick(node.id);
          }}
          onDoubleClick={() => handleNodeDoubleClick(node.id)}
        >
          <div className="member-header">
            <span>{node.name}</span>
          </div>
          <div className="member-image">
            <img 
              src={isEmptyNode ? userIcon : (node.image || userIcon)} 
              alt="Member" 
              className={isEmptyNode ? 'empty-image' : ''}
            />
            {!isEmptyNode && statusClass === 'node-premium' && <div className="package-badge">★</div>}
            {isEmptyNode && <div className="empty-indicator">⛔</div>}
            {isExpanded && <div className="expanded-indicator">▼</div>}
          </div>
        </div>
        
        {/* Tooltip - different positioning for root vs child */}
        {isFirstClick && hoveredNode === node.id && (
          isRoot ? (
            // Root node tooltip - show below
            <div className="node-hover-tooltip root-tooltip">
              <div className="tooltip-content">
                <button 
                  className="close-tooltip-btn" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseHover();
                  }}
                >
                  ×
                </button>
                
                <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
                  <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
                  <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position || 'N/A'}</p>
                  <p style={{ margin: '0 0 2px 0' }}><span>Code:</span> {node.user_code}</p>
                  <p style={{ margin: '0 0 2px 0' }}><span>Acc:</span> {node.account_name}</p>

                  {/* Volume Section */}
                  <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>LEFT VOL</p>
                      <p style={{ margin: '0', color: '#27ae60' }}>${node.leftVolume !== undefined ? node.leftVolume : 0}</p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>RIGHT VOL</p>
                      <p style={{ margin: '0', color: '#27ae60' }}>${node.rightVolume !== undefined ? node.rightVolume : 0}</p>
                    </div>
                  </div>

                  {/* Sponsor Section */}
                  {node.sponsor && (
                    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
                        Sponsor
                      </p>
                      <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
                      <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
                    </div>
                  )}
                  {node.placement && (
                    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
                        Placement
                      </p>
                      <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
                      <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            // Child node tooltip - show above (original behavior)
            <div className="node-hover-tooltip">
              <div className="tooltip-content">
                <button 
                  className="close-tooltip-btn" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseHover();
                  }}
                >
                  ×
                </button>
                
                <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
                  <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
                  <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position || 'N/A'}</p>
                  <p style={{ margin: '0 0 2px 0' }}><span>Code:</span> {node.user_code}</p>
                  <p style={{ margin: '0 0 2px 0' }}><span>Acc:</span> {node.account_name}</p>

                  {/* Volume Section */}
                  <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>LEFT VOL</p>
                      <p style={{ margin: '0', color: '#27ae60' }}>${node.leftVolume !== undefined ? node.leftVolume : 0}</p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '0' }}>RIGHT VOL</p>
                      <p style={{ margin: '0', color: '#27ae60' }}>${node.rightVolume !== undefined ? node.rightVolume : 0}</p>
                    </div>
                  </div>

                  {/* Sponsor Section */}
                  {node.sponsor && (
                    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
                        Sponsor
                      </p>
                      <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
                      <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
                    </div>
                  )}
                  {node.placement && (
                    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
                      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
                        Placement
                      </p>
                      <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
                      <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        )}
      </div>
      
      {hasChildren && isExpanded && (
        <ul className="active">
          {node.children.map(child => renderNode(child, false))}
        </ul>
      )}
    </li>
  );
};

  const handleRetry = () => {
    setError(null);
    if (userData?.user_code) {
      handleNodeClick(userData.user_code, true);
    }
  };

  return (
    <div className="genealogy-container">
      {/* Search Section */}
      <SearchSection 
        onSearch={handleSearch}
        onMyView={handleGoToMyView}
        searchLoading={searchLoading}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      
      {/* Error Message */}
      {error && (
        <div className="error-message">
          <p>Error: {error}</p>
          <button onClick={handleRetry} className="retry-btn">
            Retry
          </button>
        </div>
      )}

      <div className="genealogy-body genealogy-scroll">
        <div className="tree-legend">
          <div className="legend-item"><span className="dot premium"></span> Plan Purchase</div>
          <div className="legend-item"><span className="dot active"></span> Id Active ($5)</div>
          <div className="legend-item"><span className="dot inactive"></span> Inactive User</div>
       
        </div>

        <div className="genealogy-tree">
          {/* Fixed position volumes */}
          <div className="fixed-volume-container">
            <div className="side-volume-box left-side">
              <div className="vol-label">LEFT VOLUME</div>
              <div className="vol-value">${activeVolumes.left}</div>
            </div>

            <ul>{renderNode(treeData, true)}</ul>

            <div className="side-volume-box right-side">
              <div className="vol-label">RIGHT VOLUME</div>
              <div className="vol-value">${activeVolumes.right}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenealogyTree;